module.exports = __webpack_public_path__ + "img/image1.7c148bb2.jpg";